import { render } from "./AppFooter.vue?vue&type=template&id=1e1328fc&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "@/assets/styles/appfooter.css?vue&type=style&index=0&id=1e1328fc&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1328fc"]])

export default __exports__